import { useContext, useEffect, useState } from 'react';
import { QuickInfoItem } from './QuickInfoItem';
import { ObjectPageContext } from '../../../pages/Context/ObjectPageContext';
import QuickInfoFallback from './QuickInfoFallback';
import { General, Location, QuickInfo } from '~js/React/ObjectPageEnums';

const QuickInfoProject = () => {
  const { estate: data } = useContext(ObjectPageContext);
  const [propertyType, setPropertyType] = useState<string>('');
  const [livingArea, setLivingArea] = useState<string>('');
  const [numberOfRooms, setNumberOfRooms] = useState<string>('');
  const [isLoaded, setIsLoaded] = useState<boolean>(false);

  useEffect(() => {
    setIsLoaded(false);
    if (data?.propertyType) {
      setPropertyType(data?.propertyType);
    }
    if (
      data?.roomRange?.minValue &&
      data?.roomRange?.maxValue &&
      data?.roomRange?.minValue !== data?.roomRange?.maxValue
    ) {
      setNumberOfRooms(
        data?.roomRange?.minValue + '-' + data?.roomRange?.maxValue + ' rum'
      );
    } else if (data?.roomRange?.minValue) {
      setNumberOfRooms(data?.roomRange?.minValue + ' rum');
    } else if (data?.roomRange?.maxValue) {
      setNumberOfRooms(data?.roomRange?.maxValue + ' rum');
    }
    if (data?.livingSpaceRange?.maxValue || data?.livingSpaceRange?.minValue) {
      if (
        data?.livingSpaceRange?.maxValue &&
        data?.livingSpaceRange?.minValue &&
        data?.livingSpaceRange?.maxValue !== data?.livingSpaceRange?.minValue
      ) {
        setLivingArea(
          data?.livingSpaceRange?.minValue.toString().replace('.', ',') +
            ' - ' +
            data?.livingSpaceRange?.maxValue.toString().replace('.', ',') +
            ' m²'
        );
      } else if (data?.livingSpaceRange?.maxValue) {
        setLivingArea(
          data?.livingSpaceRange?.maxValue.toString().replace('.', ',') + ' m²'
        );
      } else if (data?.livingSpaceRange?.minValue) {
        setLivingArea(
          data?.livingSpaceRange?.minValue.toString().replace('.', ',') + ' m²'
        );
      } else if (data?.buildingInfo?.livingSpace) {
        setLivingArea(
          data?.buildingInfo?.livingSpace.toString().replace('.', ',') + ' m²'
        );
      }
    }
    setIsLoaded(true);
  }, [
    data?.propertyType,
    data?.buildingInfo?.livingSpace,
    data?.associationInfo?.numberOfLocals,
    data?.livingSpaceRange?.minValue,
    data?.livingSpaceRange?.maxValue,
  ]);

  if (!isLoaded) {
    return <QuickInfoFallback />;
  }
  return (
    <div className="flex flex-wrap lg:flex-row lg:flex-auto mt-4 lg:mt-6 px-3 lg:px-7 xxl:px-4 quickInfo font-ic max-w-7xl mx-auto">
      {livingArea && (
        <QuickInfoItem
          headline={QuickInfo.LivingSpace}
          value={livingArea}
          iconUrl={'/Images/Icons/objectPage/livingArea.svg'}
        />
      )}
      {numberOfRooms && (
        <QuickInfoItem
          headline={QuickInfo.Room}
          value={numberOfRooms}
          iconUrl={'/Images/Icons/objectPage/room.svg'}
        />
      )}
      {data?.numberOfObjects && (
        <QuickInfoItem
          headline={QuickInfo.NumberOfEstates}
          value={data?.numberOfObjects.toString() + ' st'}
          iconUrl={'/Images/Icons/objecttypes/liten_nyproduktion-black.svg'}
        />
      )}
      {data?.addressInfo?.streetAddress &&
        data?.addressInfo?.streetAddress != '-' && (
          <QuickInfoItem
            headline={Location.Address}
            value={data?.addressInfo?.streetAddress}
            iconUrl={'/Images/Icons/objectPage/location.svg'}
          />
        )}
      {data?.buildingInfo?.buildingYear && (
        <QuickInfoItem
          headline={QuickInfo.BuildingYear}
          value={data?.buildingInfo?.buildingYear}
          comment={data?.buildingInfo?.commentaryForBuildingYear}
          iconUrl={'/Images/Icons/objectPage/buildingYear.svg'}
        />
      )}
      {data?.buildingInfo?.propertyUnitDesignation && (
        <QuickInfoItem
          headline={QuickInfo.PropertyUnitDesignation}
          value={data?.buildingInfo?.propertyUnitDesignation}
          iconUrl={'/Images/Icons/objectPage/fastighetsbeteckning.svg'}
        />
      )}
      {data?.addressInfo?.municipality && (
        <QuickInfoItem
          headline={Location.Municipality}
          value={data?.addressInfo?.municipality}
          iconUrl={'/Images/Icons/objectPage/municipality.svg'}
        />
      )}
      {data?.estateTypeAsString && (
        <QuickInfoItem
          headline={QuickInfo.Type}
          value={data?.estateTypeAsString}
          iconUrl={'/Images/Icons/objectPage/type.svg'}
        />
      )}
      {propertyType && (
        <QuickInfoItem
          headline={QuickInfo.ObjectType}
          value={propertyType}
          iconUrl={'/Images/Icons/objectPage/inriktning.svg'}
        />
      )}
      {data?.dates?.possibleAccessDate && (
        <QuickInfoItem
          headline={General.AccessDate}
          value={data?.dates?.possibleAccessDate}
          iconUrl={'/Images/Icons/objectPage/access.svg'}
        />
      )}
      {data?.movingIn && (
        <QuickInfoItem
          headline={General.AccessDate}
          value={data?.movingIn}
          iconUrl={'/Images/Icons/objectPage/access.svg'}
        />
      )}
    </div>
  );
};
export default QuickInfoProject;
